export const FederatedEmailPartial = `
... on SearchFederatedEmailEntity {
	sender {
		email
		name
	}
}
`;
